export default {"bottomSection":"_bottomSection_14ere_1"};